import React, { useContext } from 'react';
import DashboardDateFilter from '../DashboardDateFilter/DashboardDateFilter';
import DashboardTimeFilter from '../DashboardTimeFilter/DashboardTimeFilter';
import { StateExporterRm } from '../../containers/RMDashboard/RmDashboard';
import { getUserType } from '../../common/utils/cookie-utils';
import TargetMonthFilter from '../../components/DashboardTargetMonthFilter/TargetMonthFilter';

const TimeFilterWrapper = ({ lastMonth, user }) => {
  const stateExporterRm = useContext(StateExporterRm);
  const userType = getUserType();
  if (userType == 1 && stateExporterRm != undefined)
    var { setChangeMonth, changeMonth } = stateExporterRm;
  return (
    <>
      <div className="inline-flex justify-between flex-wrap">
        <div className="mr-7 mt-2">
          <DashboardTimeFilter lastMonth={lastMonth} user={user} />
        </div>
        <div className="mt-2">
          <DashboardDateFilter user={user} />
        </div>
        {userType == 1 &&
        stateExporterRm != undefined &&
        typeof setChangeMonth == 'function' ? (
          <div className="xxl:mt-2 lg:ml-2">
            <TargetMonthFilter
              setChangeMonth={setChangeMonth}
              changeMonth={changeMonth}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default TimeFilterWrapper;
